import api from '../api';
import icons from '../../../../shared/utils/files/antIcons';
import getMess from '../translations';

import { notification } from 'antd';

const label = 'resetGoogleDriveRootFolder';

const handler = (actions) => {
  const { rootContainer, refresh } = actions;

  const notify = (description) => {
    notification.success({
      message: 'Success',
      top: 55,
      duration: 10,
      getContainer: rootContainer,
      description: description,
    });
  };

  api.removeGoogleDriveRootFolderExternalId().then(() => {
    refresh();

    notify('Root folder successfully reset.');
  });
};

export default (apiOptions, actions) => {
  const localeLabel = getMess(apiOptions.locale, label);

  return {
    id: label,
    icon: { icon: icons.resetRootFolder },
    label: localeLabel,
    shouldBeAvailable: (apiOptions) => {
      const resource = actions.getSelectedResources();

      return resource.length === 1 && resource[0].id.toString().endsWith('_googledrive') && resource[0].isSystemFolder === true ? true : false;
    },
    availableInContexts: ['row'],
    handler: () => handler(actions),
  };
};
